import React from 'react';
import PropTypes from 'prop-types';

class FilterSeason extends React.Component {
    constructor(props) {
        super(props);
        this.state = { season: props.initialValue, }
    }

    handleChange(event) {
        const season = event.target.value;
        this.setState({ season });
        this.props.onChange(season);
    }

    render() {
        const { label, options, selectProps } = this.props;
        const selectName = 'season-filter';
        return (
            <div className="season-filter inline">
                {label && [
                    <label key="season-filter-label-1" htmlFor={selectName}>{label}</label>,
                    <br key="season-filter-label-2"/>,
                ]}
                <select
                    name={selectName}
                    className="form-control"
                    disabled={options.length < 1}
                    onChange={this.handleChange.bind(this)}
                    value={this.state.season}
                    {...selectProps}
                >
                    {options.length < 1 && <option value={null}>En attente de données...</option>}
                    {options.map(({ value, text, ...rest }) => (
                        <option key={value} value={value} {...rest}>{text}</option>
                    ))}
                </select>
            </div>
        )
    }
}

FilterSeason.propTypes = {
    initialValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, value: PropTypes.string })),
    selectProps: PropTypes.object,
};

FilterSeason.defaultProps = {
    initialValue: null,
    options: [],
    selectProps: {},
};

export default FilterSeason



// WEBPACK FOOTER //
// ./src/components/Filters/Season/index.js